<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addSale, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    modal-import(model="" :title="$t('front.import_modal', {model: $t('strings.sale')})")
    modal-sales(:newRecord='newRecord', :is-add='isModalAdd')
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.sales') }}:
            span {{ $t('strings.description', {attribute: $t('strings.sales')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          div
            vm-button(icon="plus" disabled='' @click="addSale") {{ $t('strings.add') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReport({ format: 'excel' })")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="deleteSalesConfirm" :disabled="!enabledDelete")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="setModalImportVisible(true)")
                    vm-icon(icon="upload-outline")
                    slot &nbsp;{{ $t('strings.import') }}
                  //- More options
                      Agrega mas acciones para colecciones de datos
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(multiple v-model="selected"  max-height="350px" :data="sales")
            template(slot="header")
              .d-flex.justify-content-between
                vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)"  width="300px")
                div
                  vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilter(filters)" size="small" width="200px" :serializer="item => $t('sales.'+ item)")
                  vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                    vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                      vm-button(type="default" icon="funnel-outline" size="small")

                      vm-dropdown-menu(class="filters")
                        .heading.d-flex.justify-content-between
                          h4 {{ $t('strings.filters') }}
                          vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                            //- vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                              vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                            //- vm-select.filter(url="customers" columns="tradename,etc" :placeholder="$t('strings.multiple')" multiple autocomplete :label="$t('sales.customer_id')" v-model="filters.whereIn.customer_id" @input-change="autoCompleteFunc")
                              vm-select-item(:key="index" :value="item.id" :text="item.tradename" v-for="(item,index) in LSalesCatalog.customers")
                            vm-date-picker.filter(type="daterange" :label="$t('sales.created_at')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")

                            //- NOTA: (agregar clase .filter)
                        .filter.d-flex
                          vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                  vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                    vm-button(type="default" size="small" icon="list")
                  vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                    vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('sales.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                  slot(v-if="column == 'map_id' && item.id === data[indextr]['map_id']" v-for='item,index in maps') {{item.title}}
                  //- slot(v-if="column == 'client_id' && item.id === data[indextr]['client_id']" v-for='item,index in clients') {{ item.names + ' ' + item.f_last_name + ' ' + item.m_last_name }}
                  slot(v-if="column != 'status' && column != 'total' && column != 'amount' && column != 'unit_price' && column != 'map_id' && column != 'client_id'" ) {{data[indextr][column] }}
                  slot(v-if="column === 'amount'") ${{data[indextr][column].toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString()}}
                  vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status_display']}}
                vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(@click="editSale(data[indextr], tr)")
                      vm-icon(icon="edit-2-outline")
                      slot &nbsp;{{ $t('strings.change_lot') }}
                    vm-dropdown-item.d-flex.justify-content-between(@click="setActionSale(data[indextr], 'cancelled')")
                      vm-icon(icon="close-circle-outline")
                      slot &nbsp;{{ $t('strings.cancel') }}
                    //- vm-dropdown-item.d-flex.justify-content-between(@click="deleteSaleConfirm(data[indextr])")
                    //-   vm-icon(icon="trash-2-outline")
                    //-   slot &nbsp;{{ $t('strings.delete') }}
                    //- vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == '1'" @click="setActionSale(data[indextr], 'invoiced')")
                    //-   vm-icon(icon="checkmark-circle-outline")
                    //-   slot &nbsp;{{ $t('strings.action_invoiced') }}
                    //- vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == '3'" @click="editSale(data[indextr])")
                    //-   vm-icon(icon="eye-outline")
                    //-   slot &nbsp;{{ $t('strings.view') }}
                    //- More actions
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
          transition(name="enter")
            .total-records(v-if="total>0") Total: {{ total | currency }}
</template>

<script>
import ModalSales from '@/components/modals/ModalSales.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Sales')

export default {
  name: 'Sales',
  components: {
    ModalSales,
    ModalImport
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    newRecord: {},
    selected: [],
    columns: [
      'lot_id',
      'lot_title',
      'map_id',
      'client',
      'transaction_date',
      'amount',
      'status'
    ],
    columnsOrderBy: [
      // Nota solo si las columnas son atributos
      'transaction_date',
      'status'
    ],
    status: [
      {
        text: 'Compleada',
        value: 1,
        color: 'success'
      },
      {
        text: 'Cancelada',
        value: 2,
        color: 'danger'
      },
      {
        text: 'Pendiente',
        value: 3,
        color: 'warning'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        map_id: '',
        client: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    await this.getClients()
    await this.getMaps()
    await this.getSales(1)
    // await this.getSalesCatalog()
  },
  methods: {
    ...mapActions([
      'deleteSale',
      'deleteSales',
      'loadSales',
      'loadMaps',
      'loadClients',
      'loadCatalog',
      'getSalesCatalog',
      'actionSale',
      'setModalImportVisible',
      'setModalVisible',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    async getMaps (page) {
      this.loadMaps()
    },
    async getClients () {
      this.loadClients()
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.sales.findIndex(u => u.id === this.selected[0].id)
      this.editSale(this.selected[0], idx)
    },
    addSale () {
      this.isModalAdd = true
      this.setModalVisible(true)
      this.newRecord = {}
    },
    editSale (sale, index) {
      if (!this.$auth.check('Contabilidad')) {
        this.isModalAdd = false
        this.setModalVisible(true)
        this.newRecord = { ...sale }
      }
    },
    async deleteSaleConfirm (sale) {
      let t = this
      this.auxDeleteSale = () => {
        t.deleteSale(sale).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.cancel_modal'),
        text: this.$t('front.cancel_confirmation', { model: this.$t('strings.sale') }),
        accept: this.auxDeleteSale
      })
    },
    async deleteSalesConfirm () {
      let t = this
      let salesMany = parseDeleteMany(this.selected, 'id')
      this.auxDeleteSale = () => {
        t.deleteSales(salesMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.cancel_confirmation', { model: this.$t('strings.sale') }),
        accept: this.auxDeleteSale
      })
    },
    async setActionSale (record, action) {
      if (!this.$auth.check('Contabilidad')) {
        this.auxDeleteSale = () => {
          record.id && this.actionSale({ id: record.id, action })
        }
        this.$vm.dialog({
          color: 'danger',
          title: this.$t('front.cancel_modal'),
          text: this.$t('front.cancel_confirmation', { model: this.$t('strings.sale') }),
          accept: this.auxDeleteSale
        })
      }
    },
    async getSales (page) {
      let t = this
      this.loadSales({ page }).then(data => t.getProps(t.$route.params.id))
    },
    getProps (index) {
      let sale = this.sales.filter(sale => sale.id === parseInt(index))[0]
      sale && this.editSale(sale, index)
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    newObjectFuncModal (value) {
      //
    },
    newObjectFuncView (value) {
      //
    },
    handleChange (date) {
      // this.filters.betweenDates.created_at = date
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  },
  computed: {
    ...mapGetters([
      'sales',
      'maps',
      'clients',
      'pagination',
      'filterParams'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('sales.' + column)}` : `${str} ${t.$t('sales' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.sale'), columns: concatColumns, column: this.$t('sales.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getSales(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getSales(this.currentPage)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  float: left;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
